<template>
  <div id="nav">
    <router-link to="/"
      ><img alt="Plantscape" src="images/logo.png"
    /></router-link>
    <span v-if="loggedin">
      | <router-link to="/jobs">Jobs</router-link> |
      <router-link to="/reports">Reports</router-link> |
      <router-link to="/admin">Admin</router-link> |
      <router-link to="/logout">Logout</router-link></span
    >
  </div>
</template>

<script>
import { mapState } from "vuex";

export default {
  computed: {
    ...mapState({
      loggedin: state => state.account.user,
    }),
  },
};
</script>
